<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form
        layout="inline"
        @submit="handleSearch"
        :autoFormCreate="
          (form) => {
            this.searchForm = form;
          }
        "
      >
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="姓名" fieldDecoratorId="real_name">
              <a-input placeholder="名称" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="手机号" fieldDecoratorId="phone_number">
              <a-input placeholder="sku" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="门店" fieldDecoratorId="branch_id">
              <a-select placeholder="请选择"  allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in branches" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="角色" fieldDecoratorId="role" allowClear>
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in rolList" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" htmlType="submit">查询</a-button>
              <a-divider type="vertical" />
              <a-button type="primary" @click="handleAdd">新增</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table ref="table" size="default" :columns="columns" :data="loadData">
      <template slot="roleContent" slot-scope="text">
        {{ text | roleNameFFilter }}
      </template>
      <template slot="lockedContent" slot-scope="text">
        {{ text ? "不可用" : "可用" }}
      </template>
      
      <template slot="action" slot-scope="text, record">
        <div class="editable-row-operations">
          <a @click="handleChange(record)">管理</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定删除此员工吗？"
            @confirm="handleDelete(record)"
            okText="是"
            cancelText="否"
          >
            <a>删除</a>
          </a-popconfirm>
        </div>
      </template>
    </s-table>
    <a-modal
      :visible="showModal"
      size="middle"
      @cancel="handleClose"
      title="员工管理"
      @ok="handleOk"
    >
      <a-form
        :autoFormCreate="
          (form) => {
            this.staffForm = form;
          }
        "
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-item label="员工姓名">
          <a-input v-model="staffInfo.real_name" placeholder="请输入员工姓名" />
        </a-form-item>
        <a-form-item
          label="员工头像"
          fieldDecoratorId="avatar"
          :fieldDecoratorOptions="{
            rules: [{ required: true, message: '请上传商品图片' }],
            initialValue: staffInfo.avatar,
          }"
        >
          <a-upload
            name="file"
            listType="picture-card"
            class="avatar-uploader"
            :showUploadList="false"
            action="//upload.qiniup.com"
            :beforeUpload="beforeCoverUpload"
            :data="imgForm"
            @change="handleCoverChange"
          >
            <img
              width="128"
              height="128"
              v-if="staffInfo.avatar"
              :src="staffInfo.avatar"
            />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item label="手机号码">
          <a-input
            v-model="staffInfo.phone_number"
            placeholder="请输入手机号码"
          />
        </a-form-item>
        <a-form-item label="角色">
          <a-select placeholder="请选择" v-model="staffInfo.role" allowClear show-search option-filter-prop="children">
            <a-select-option v-for="item in rolList" :key="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="帐号" v-if="modalType === 'add'">
          <a-input v-model="staffInfo.username" placeholder="请输入登录帐号" />
        </a-form-item>
        <a-form-item label="归属门店">
          <a-select placeholder="请选择" v-model="staffInfo.branch_id" allowClear show-search option-filter-prop="children">
            <a-select-option v-for="item in branches" :key="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="状态">
          <a-select placeholder="请选择" v-model="staffInfo.locked">
            <a-select-option :key="false">可用</a-select-option>
            <a-select-option :key="true">不可用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="密码">
          <a-input v-model="staffInfo.password" placeholder="请输入密码" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import { getBranchList } from "@/api/branch";
import { deleteStaff, updateStaff, getStaffList } from "@/api/staff";
import { getQiniuToken } from "@/api/qiniu";

export default {
  name: "OptionList",
  components: {
    STable,
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      loading: false,
      searchForm: null,
      imgForm: {},
      avatar: "",
      queryParam: {}, // 表头
      row: {},
      modalType: "add",
      rolList: [
        { id: "clerk", name: "店员" },
        { id: "manager", name: "店长" },
        { id: "merchandiser", name: "采购" },
        { id: "operations", name: "运营" },
        { id: "admin", name: "管理员" },
      ],
      branches: [],
      branch_id: 0,
      staffInfo: {},
      showModal: false,
      staffForm: null,
      columns: [
        {
          title: "姓名",
          dataIndex: "real_name",
        },
        {
          title: "手机号码",
          dataIndex: "phone_number",
        },
        {
          title: "帐号",
          dataIndex: "username",
        },
        {
          title: "归属门店",
          dataIndex: "branch_name",
        },
        {
          title: "角色",
          dataIndex: "role",
          scopedSlots: { customRender: "roleContent" },
        },
        {
          title: "状态",
          dataIndex: "locked",
          scopedSlots: { customRender: "lockedContent" },
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      loadData: (params) => {
        return getStaffList(Object.assign(params, this.queryParam)).then(
          (res) => res
        );
      },
    };
  },
  created() {
    this.getBranchList();
  },
  computed: {
    hasSelected() {
      return this.selectedRows.length > 0;
    },
  },
  methods: {
    getBranchList: function () {
      getBranchList().then((res) => {
        this.branches = res.list;
      });
    },
    handleSearch(e) {
      e.preventDefault();
      this.queryParam = {
        real_name: this.searchForm.getFieldValue("real_name"),
        phone_number: this.searchForm.getFieldValue("phone_number"),
        branch_id: this.searchForm.getFieldValue("branch_id"),
        role: this.searchForm.getFieldValue("role"),
      };
      this.$refs.table.refresh();
    },
    handleAdd() {
      this.staffInfo = {};
      this.showModal = true;
      this.modalType = "add";
    },
    beforeCoverUpload: function () {
      let _this = this;
      return getQiniuToken().then((res) => {
        _this.bucketHost = res.bucket_host;
        _this.imgForm = {
          token: res.qiniu_token,
        };
      });
    },
    handleCoverChange(info) {
      if (info.file.status === "uploading") {
        this.loading = true;
      } else if (info.file.status === "done") {
        let key = info.file.response.key;
        this.staffInfo.avatar = `${this.bucketHost}${key}`;
        this.loading = false;
      } else if (info.file.status === "error") {
        this.loading = false;
        this.$message.error("上传图片失败，请重试");
      } else if (info.file.status === "removed") {
        console.log("removed");
      }
    },
    handleChange(record) {
      this.staffInfo = { ...record };
      this.showModal = true;
      this.modalType = "edit";
    },
    handleDelete(row) {
      deleteStaff(row.id).then((res) => {
        this.$refs.table.refresh();
        this.$message.success("删除成功");
      });
    },
    handleClose() {
      this.staffInfo = {};
      this.showModal = false;
      this.modalType = "add";
    },
    handleOk() {
      const vm = this;
      this.staffForm.validateFields((err, values) => {
        if (!err) {
          const params = {
            id: this.staffInfo.id,
            real_name: this.staffInfo.real_name,
            username: this.staffInfo.username,
            phone_number: this.staffInfo.phone_number,
            role: this.staffInfo.role,
            branch_id: this.staffInfo.branch_id,
            locked: this.staffInfo.locked,
            password: this.staffInfo.password,
            avatar: vm.staffInfo.avatar,
          };
          // 这里判断一下id是否存在
          updateStaff(params).then((res) => {
            this.$message.success("操作成功");
            this.showModal = false;
            this.staffInfo = {};
            this.$refs.table.refresh();
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.pic {
  width: 60px;
  height: 60px;
}
.pic > img {
  width: 60px;
  height: 60px;
  display: block;
}
</style>

